import { i18nReducer } from 'react-redux-i18n'
import { combineReducers } from 'redux'

import app from './app'
import compositionFilters from './compositionFilters'
import compositions from './compositions'
import modal from './modal'
import theatres from './theatres'
import user from './user'

/* export actions */
export * from './theatres'
export * from './compositions'
export * from './modal'
export * from './user'
export * from './compositionFilters'
export * from './app'

export default combineReducers({
  app,
  theatres,
  compositions,
  modal,
  user,
  compositionFilters,
  i18n: i18nReducer
})


// WEBPACK FOOTER //
// ./src/app/actions/index.js